import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Reloads the collection when a responsible person is changed.
 */
export const reloadOnResponsiblePersonChange = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    ec.models.CollectionProducer.getEc$(
      ec.Name.Predefined.SpaceResponsiblePerson,
      {
        waitUntilReady: true,
      },
    ).pipe(
      rxjs.switchMap(responsiblePersonEc =>
        responsiblePersonEc.plugins.editingPlugin.feature.actions.submit.success
          .observe()
          .pipe(
            rxjs.map(() =>
              collection.plugins.currentEntityPlugin.feature.actions.getEntity
                .from('(effect) reload on responsible person change')
                .create({}),
            ),
          ),
      ),
    ),
)
